import React from 'react';

import { MembershipMode } from 'utils/api/modules/memberGroups';

import { isDynamicGroup, isManualGroup } from 'containers/MemberGroups/utils/membership';
import {
  TypeCard,
  TypeCardDesc,
  TypeCardRow,
  TypeCardTitle,
  TypeCardTop,
  TypeRadioDot,
} from './MemberGroupForm.styles';

const MembershipTypeCards: React.FunctionComponent<{
  value: MembershipMode;
  onChange?: (mode: MembershipMode) => void;
}> = ({ value, onChange }) => {
  const select = (mode: MembershipMode): void => onChange?.(mode);
  const isManual = isManualGroup({ membershipMode: value });
  const isDynamic = isDynamicGroup({ membershipMode: value });

  return (
    <TypeCardRow role="radiogroup" aria-label="Membership type">
      <TypeCard
        $selected={isManual}
        role="radio"
        aria-checked={isManual}
        tabIndex={isManual ? 0 : -1}
        onClick={() => select(MembershipMode.Manual)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            select(MembershipMode.Manual);
          }
        }}
      >
        <TypeCardTop>
          <TypeRadioDot $selected={isManual} />
          <TypeCardTitle>Manual</TypeCardTitle>
        </TypeCardTop>
        <TypeCardDesc>Members are added and removed manually.</TypeCardDesc>
      </TypeCard>

      <TypeCard
        $selected={isDynamic}
        role="radio"
        aria-checked={isDynamic}
        tabIndex={isDynamic ? 0 : -1}
        onClick={() => select(MembershipMode.Dynamic)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            select(MembershipMode.Dynamic);
          }
        }}
      >
        <TypeCardTop>
          <TypeRadioDot $selected={isDynamic} />
          <TypeCardTitle>Dynamic</TypeCardTitle>
        </TypeCardTop>
        <TypeCardDesc>
          Members are added automatically from your conditions, and update as users’ details change.
        </TypeCardDesc>
      </TypeCard>
    </TypeCardRow>
  );
};

export default MembershipTypeCards;
